import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKeyboardArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "1em",
	viewBox: "0 -960 960 960",
	width: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M480-599q-8 0-15 2.5t-13 8.5L268-404q-11 11-11 28t11 28q11 11 28 11t28-11l156-156 156 156q11 11 28 11t28-11q11-11 11-28t-11-28L508-588q-6-6-13-8.5t-15-2.5Z" })
});
export default SvgKeyboardArrowUp;
